import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
@Component({
    selector: 'users-base',
    template: `<ng-content></ng-content>`,
})
export class BaseComponent implements OnDestroy {
    protected subscriptions = new Array<Subscription>();

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscribe) => {
            subscribe.unsubscribe();
        });
    }
}
